// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"40defcef","213":"5151cf28","363":"08bea6e7","446":"66778104","455":"524f4283","660":"db44a164","789":"97b8af08","996":"46627038","997":"64a1a9d5"}[chunkId] + ".chunk.js";
};